/* WFC — storefront helpers:
   (1) hide the "Floor Stock" variant option online (Floor Stock is POS/in-store only), and
   (2) show the real "available after" date on pre-sale / backorder items.
   Does NOT affect POS, receipts or emails. Remove by deleting this file + its include lines. */
(function(){
  var HIDDEN = ['floor stock']; // option values (lowercased) to hide online
  function hide(v){ return v && HIDDEN.indexOf(String(v).trim().toLowerCase()) !== -1; }
  function hideFloor(){
    var scopes = document.querySelectorAll('.product-form');
    if(!scopes.length){ scopes = [document]; }
    Array.prototype.forEach.call(scopes, function(scope){
      Array.prototype.forEach.call(scope.querySelectorAll('input.product-form__single-selector'), function(inp){
        if(hide(inp.value)){
          if(inp.checked){
            var alt = scope.querySelector('input.product-form__single-selector[name="'+inp.name+'"]:not([value="'+inp.value+'"])');
            if(alt){ alt.checked = true; alt.dispatchEvent(new Event('change',{bubbles:true})); }
          }
          var opt = inp.closest('.product-form__option');
          if(opt){ opt.style.display = 'none'; }
        }
      });
      Array.prototype.forEach.call(scope.querySelectorAll('select.product-form__single-selector option, select[name="id"] option, select[id^="product-select"] option'), function(o){
        var t = (o.textContent||'').toLowerCase();
        if(hide(o.value) || t.indexOf('floor stock') !== -1){ o.remove(); }
      });
    });
  }
  function presaleLabel(){
    var d = window.__wfcAvailableAfter;
    if(!d){ return; }
    Array.prototype.forEach.call(document.querySelectorAll('.product-form__inventory'), function(el){
      if(/back\s*order/i.test(el.textContent||'')){ el.textContent = 'Pre-order — ships after ' + d; }
    });
  }
  function run(){ try{ hideFloor(); }catch(e){} try{ presaleLabel(); }catch(e){} }
  if(document.readyState !== 'loading'){ run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('DOMContentLoaded', function(){
    try{ new MutationObserver(function(){ run(); }).observe(document.body, {childList:true, subtree:true}); }catch(e){}
  });
})();
